interface Opera {
  id: number,
  title: string;
  composer: string;
  language: string;
  premiere: string;
  image: string;
  description: string;
}

export const operas: Opera[] = [
  {
    id: 1,
    title: "Manon Lescaut",
    composer: "Giacomo Puccini",
    language: "Italian",
    premiere: "",
    image: "manon-lescaut.jpg",
    description: "",
  },
  {
    id: 2,
    title: "Tosca",
    composer: "Giacomo Puccini",
    language: "Italian",
    premiere: "",
    image: "tosca.jpg",
    description: "",
  },
  {
    id: 3,
    title: "Madame Butterfly",
    composer: "Giacomo Puccini",
    language: "Italian",
    premiere: "",
    image: "madame-butterfly.jpg",
    description: "",
  },
  {
    id: 4,
    title: "Turandot",
    composer: "Giacomo Puccini",
    language: "Italian",
    premiere: "",
    image: "turandot.jpg",
    description: "",
  },
  {
    id: 5,
    title: "La bohème",
    composer: "Giacomo Puccini",
    language: "Italian",
    premiere: "",
    image: "la-boheme.jpg",
    description: "",
  },
  {
    id: 6,
    title: "Giulio Cesare",
    composer: "George Frideric Handel ",
    language: "Italian",
    premiere: "",
    image: "giulio-cesare.jpg",
    description: "",
  },
  {
    id: 7,
    title: "Le nozze di Figaro ",
    composer: "Wolfgang Amadeus Mozart ",
    language: "Italian",
    premiere: "",
    image: "le-nozze-di-figaro.jpg",
    description: "",
  },
  {
    id: 8,
    title: "Don Giovanni",
    composer: "Wolfgang Amadeus Mozart ",
    language: "Italian",
    premiere: "",
    image: "don-giovanni.jpg",
    description: "",
  },
  {
    id: 9,
    title: "Così fan tutte",
    composer: "Wolfgang Amadeus Mozart",
    language: "Italian",
    premiere: "",
    image: "cosi-fan-tutte.jpg",
    description: "",
  },
  {
    id: 10,
    title: "Die Zauberflöte ",
    composer: "Wolfgang Amadeus Mozart",
    language: "German",
    premiere: "",
    image: "die-zauberflote.jpg",
    description: "",
  },
  {
    id: 11,
    title: "Il barbiere di Siviglia",
    composer: "Gioacchino Rossini ",
    language: "Italian",
    premiere: "",
    image: "il-barbiere-di-siviglia.jpg",
    description: "",
  },
  {
    id: 12,
    title: "L'elisir d'amore ",
    composer: "Gaetano Donizetti",
    language: "Italian",
    premiere: "",
    image: "l-elisir-d-amore.png",
    description: "",
  },
  {
    id: 13,
    title: "Rienzi",
    composer: "Richard Wagner",
    language: "German",
    premiere: "",
    image: "rienze.jpg",
    description: "",
  },
  {
    id: 14,
    title: "Tannhäuser",
    composer: "Richard Wagner",
    language: "German",
    premiere: "",
    image: "tannhauser.jpg",
    description: "",
  },
  {
    id: 15,
    title: "Lohengrin",
    composer: "Richard Wagner",
    language: "German",
    premiere: "",
    image: "lohengrin.jpg",
    description: "",
  },
  {
    id: 16,
    title: "Die Walküre",
    composer: "Richard Wagner",
    language: "German",
    premiere: "",
    image: "die-walkure.jpg",
    description: "",
  },
  {
    id: 17,
    title: "Götterdämmerung",
    composer: "Richard Wagner",
    language: "German",
    premiere: "",
    image: "gotterdammerung.jpg",
    description: "",
  },
  {
    id: 18,
    title: "Parsifal",
    composer: "Richard Wagner",
    language: "German",
    premiere: "",
    image: "parsifal.jpg",
    description: "",
  },
  {
    id: 19,
    title: "Nabucco",
    composer: "Giuseppe Verdi",
    language: "Italian",
    premiere: "",
    image: "nabucco.jpg",
    description: "",
  },
  {
    id: 20,
    title: "Rigoletto",
    composer: "Giuseppe Verdi",
    language: "Italian",
    premiere: "",
    image: "rigoletto.jpg",
    description: "",
  },
];
